import React from 'react';
import Icon from '../../../components/AppIcon';

const WeeklyContentSection = () => {
  const contentCards = [
    {
      id: 1,
      icon: "Euro",
      iconColor: "var(--color-accent)",
      title: "Open Calls for Funding Opportunities",
      description: "A deep dive into the intricacies of EU funding... without wading through endless pages of unnecessary information!",
      quote: "The European Commission has announced a new funding opportunity in the field of school education..."
    },
    {
      id: 2,
      icon: "Euro",
      iconColor: "var(--color-accent)",
      title: "National Agencies\' Funding Rates",
      description: "Explore our comprehensive data templates: National Agencies' funding, rated and compared across countries!",
      quote: "In the March 2025 open call, the Slovak NA funded only 17% of all submitted KA220-SCH projects..."
    },
    {
      id: 3,
      icon: "FileEdit",
      iconColor: "var(--color-accent)",
      title: "Project-Writing Tips",
      description: "Sometimes, you might be so passionately invested in writing your project, that you forget the obvious. Or the extra step that will impress the evaluators!",
      quote: "The connection to the EU priorities must be explained in each WP or Activity!"
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-muted/30">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
            What You'll Receive Every Week
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Curated content designed to keep you informed and competitive in the research funding landscape
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {contentCards?.map((card) => (
            <div
              key={card?.id}
              className="group bg-card border border-border rounded-xl p-8 shadow-elevation-sm hover:shadow-elevation-md transition-all duration-300 ease-smooth hover:-translate-y-1"
            >
              <div className="flex items-center justify-center w-14 h-14 bg-primary/10 rounded-lg mb-6 group-hover:scale-110 transition-transform duration-300">
                <Icon name={card?.icon} size={28} color={card?.iconColor} />
              </div>

              <div className="flex items-center gap-2 mb-3">
                <h3 className="text-xl font-heading font-semibold text-foreground">
                  {card?.title}
                </h3>
              </div>

              <p className="text-sm text-muted-foreground leading-relaxed">
                {card?.description}
              </p>

              {card?.quote && (
                <div className="mt-4 pt-4 border-t border-border/50">
                  <p className="text-xs text-muted-foreground italic leading-relaxed">
                    {card?.quote}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WeeklyContentSection;